import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ReverseAuctionBidCtrl', ReverseAuctionBidCtrl);

    function ReverseAuctionBidCtrl(
        $routeParams,
        auctionResource,
        DATES,
        authService
    ) {
        var vm = this;

        vm.auction = {};
        vm.isLoggedIn = !!authService.getLoggedInUser();
        vm.auctionBid = {};
        vm.auctionId = $routeParams.id;
        vm.DATES = DATES;
        vm.config = {};
        vm.auction = {};
        vm.isBidPost = false;
        vm.uiLoading = true;
        vm.countDown = {};

        auctionResource.get(
            { auctionId: vm.auctionId, isBuyBackAuction: true },
            function (res) {
                vm.auction = res;
                calculateTargetTime(vm.auction);
                vm.uiLoading = false;
            },
            function () {
                // TODO
            }
        );

        auctionResource.config(
            { auctionId: vm.auctionId },
            function (res) {
                vm.config = res;
            },
            function () {
                // TODO
            }
        );

        function calculateTargetTime(auction) {
            if (auction.phase == 'PUBLISHED') {
                vm.countDown.targetTime = auction.nextOpen;
            } else if (auction.phase == 'OPEN') {
                vm.countDown.targetTime = auction.nextClose;
            }
        }
    }
})();
